<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-card-view`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 6H5l-.116.007A1.004 1.004 0 004 7v2l.007.116c.058.496.482.884.993.884h38l.116-.007C43.612 9.935 44 9.511 44 9V7l-.007-.116A1.004 1.004 0 0043 6zm1 11a2 2 0 00-2-2H6a2 2 0 00-2 2v15a2 2 0 002 2h36a2 2 0 002-2V17zm-1 22H5l-.116.007A1.004 1.004 0 004 40v2l.007.116c.058.496.482.884.993.884h38l.116-.007c.496-.058.884-.482.884-.993v-2l-.007-.116A1.003 1.003 0 0043 39zm-3-20H8v11h32V19z"/></svg>
</template>
<script>

export default {
  name: 'IconCardView',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
